import { useEffect } from 'react';

/**
 * Dá título à aba e, opcionalmente, uma classe ao `<body>`.
 *
 * ## Por que isto existe
 *
 * Antes cada tela era um HTML próprio, com seu `<title>` e sua tag `<body>`.
 * Numa aplicação de página única existe um só de cada, e as duas coisas passam
 * a ser estado que muda com a rota.
 *
 * A classe no `body` não é preciosismo: `signin.css` estiliza `body.entrar` e
 * `app.css` estiliza `body`. As duas folhas convivem no mesmo pacote, e é a
 * classe que decide qual vence — sem ela, a tela de entrada herda o fundo do
 * painel de status.
 *
 * A limpeza no retorno do efeito é o que impede a classe de vazar para a
 * próxima tela: sem ela, quem saísse da entrada levaria o fundo junto.
 */
export function usePageMeta(title, bodyClass) {
  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    if (!bodyClass) return undefined;
    document.body.classList.add(bodyClass);
    return () => document.body.classList.remove(bodyClass);
  }, [bodyClass]);
}
